/** Deterministic PRNG so every fixture is byte-identical across runs and machines. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6d2b79f5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

const HEX = '0123456789abcdef'

/** A v4-shaped UUID drawn from the seeded stream — valid for the schemas, stable for tests. */
export function seededId(rng: () => number): string {
  let out = ''
  for (let i = 0; i < 32; i += 1) {
    if (i === 12) {
      out += '4'
      continue
    }
    if (i === 16) {
      out += HEX[8 + Math.floor(rng() * 4)]
      continue
    }
    out += HEX[Math.floor(rng() * 16)]
  }
  return `${out.slice(0, 8)}-${out.slice(8, 12)}-${out.slice(12, 16)}-${out.slice(16, 20)}-${out.slice(20)}`
}

export function pick<T>(rng: () => number, values: readonly T[]): T {
  return values[Math.floor(rng() * values.length)] as T
}
